import React, { useEffect } from 'react'
import Grid from '../../components/Grid'
import { useLocation, useNavigate, useParams } from 'react-router'
import useFetchCollections from './hooks/useFetchCollections'
import Spinner from '../../components/Spinner'
import { useAppDispatch, useAppSelector } from '../../hooks/useStore'
import {
  ComcastErrorType,
  getUrlSearchParameter,
} from '../../../../shared/helpers'
import {
  KeyTypeEnum,
  useKeyDown,
} from '../../../../shared/providers/KeyDownProvider'
import googleAnalytics4 from '../../lib/googleAnalytics'
import tts from '../../lib/TTS'
import { Collection } from './types'

const STATIONID = 'station_id'

function CollectionScreen() {
  const params = useParams<{ url: string }>()
  const dispatch = useAppDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  const { station_id: stationId } = useAppSelector((state) => state.station)
  let link = decodeURIComponent(params.url as string)

  const stationIdFromUrl = getUrlSearchParameter(location.search, STATIONID)
  if (!stationIdFromUrl) {
    link += `?${STATIONID}=${stationId}`
  }
  const {
    loading,
    error,
    value: collectionResponse,
  } = useFetchCollections(link)

  // Workaround to allow new focus components to work with spatial navigation and old components work with focusable HoC
  // TODO: remove this when whole app is migrated to react spatial navigation
  useEffect(() => {
    window.focusedComponent = {}
    window.focusedComponent.handleBySpatialNavigation = true
    return () => {
      window.focusedComponent.handleBySpatialNavigation = false
    }
  }, [])

  useEffect(() => {
    if (!error) return
    dispatch({
      type: 'TRIGGER_ERROR',
      payload: {
        error,
        content: {
          errorPath: location.pathname,
        },
        codeBaseLocation: 'CollectionsScreen - getCollectionData',
        errorType: ComcastErrorType.network,
      },
    })
    navigate('/error', { replace: true })
  }, [error, location.pathname])

  useEffect(() => {
    const resourceTitle = collectionResponse?.resource?.title
    const collectionTitle = collectionResponse?.collections[0]?.title

    if (!loading && resourceTitle) {
      googleAnalytics4.sendPageViewEvent(
        `See All Collections | ${resourceTitle}`
      )
    }

    if (!loading && collectionTitle && resourceTitle) {
      tts.pushTextToRead(`${resourceTitle}`)
      tts.addTextToRead(`${collectionTitle}`)
    }
  }, [loading, collectionResponse])

  useKeyDown(KeyTypeEnum.Back, () => navigate(-1))
  return (
    <div className="collection-screen__container">
      {loading && <Spinner />}
      {!loading &&
        collectionResponse &&
        collectionResponse.collections?.[0] && (
          <Grid
            collections={collectionResponse.collections?.[0] as Collection}
            title={collectionResponse?.resource?.title}
          />
        )}
    </div>
  )
}

export default CollectionScreen
